import styled from 'styled-components';
import {
  darkGrey,
  orange,
  white,
  greyShadow,
  textGrey,
  bgPurple,
} from '../../constants/theme';

export const Container = styled.nav`
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .navBar-ul {
    display: flex;
    list-style: none;
    align-items: center;

    li {
      a {
        padding: 0 10px;
        margin: 37px 0;
        font-size: 16px;
        font-weight: 300;
        color: ${darkGrey};
        text-decoration: none;

        &:hover {
          text-decoration: underline;
          color: ${textGrey};
        }
        &.active {
          text-decoration: underline;
          color: ${textGrey};
          svg {
            border-bottom: 1px solid ${greyShadow};
          }
        }
        &.home {
          font-size: 22px;
          color: ${greyShadow};
          &:hover {
          color: ${white};
          text-decoration: underline;
          }
          
        .home-img {
          height: 16px;
          width: 16px;
          &.active {
            height: 18px
            border-bottom: 1px solid ${darkGrey};
            padding-bottom: 2px;
          }
        }
        }
        &.last {
          background-color: ${orange};
          color: ${white};
          font-weight: bold;
          padding: 12px 30px;
          &:hover {
            color: ${white};
            text-decoration: underline;
          }
        }
      }
      & + li {
        margin-left: 2rem;
      }
    }
  }

  //STYLE MOBILE
    @media (min-width: 320px) and (max-width: 1024px) {
   .navbar {
      width: 100%;
      padding-left: 0;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.05);
      button {
        padding: 0;
        svg {
          font-size: 37px;
          color: ${bgPurple};
          outline: none;
          opacity: 1;
        }
        &:hover {
          outline: none;
        }
        &:active {
          outline: none;
        }
        &:focus {
          outline: none;
        }
      }
      .navbar-expand {
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.05);
      }
      .navbar-toggler {
        display: block;
        padding: 15px 15px 15px 18px;
      }
      .navBar-ul {
        text-align: left;
        flex-direction: column;
        padding-top: 30px;
        li {
          width: 100%;
          margin-top: 30px;
          a {
            text-align: left;
            padding: 15px 0;
            margin: 0;
            &.home {
              padding: 0 10px;
            }
            // &.last {
            //   display: none;
            // }
          }
        }
      }
    }
    .navbar-collapse {
      position: absolute;
      font-weight: 300;
      top: 80px;
      align-items: flex-start;
      z-index: 9999;
      right: 1000%;
      padding: 15px 28px;
      width: 100%;
      transition: all 0.3s ease;
      display: block;
      background-color: ${white};
      box-shadow: 0px 0px 6px 5px #f5f5f5;
    }
    .navbar-collapse.collapsing {
      height: auto !important;
      margin-right: 150%;
      transition: all 0.3s ease;
      display: block;
    }
    .navbar-collapse.show {
      width:100%;
      right: 0px;
      height: 100vh;
    }
  }
`;
